<script setup lang="ts">
import password from '@/routes/password'
import { Head, useForm } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  email: string
  token: string
}>()

const form = useForm({
  email: props.email,
  token: props.token,
  password: null,
  password_confirmation: null,
})
</script>

<template>
  <Head :title="t('title')" />

  <AuthCard>
    <template #title>{{ t('title') }}</template>
    <template #subtitle>{{ t('subtitle') }}</template>

    <template #content>
      <InertiaFormField :label="t('form.password.label')" required :error="form.errors.password">
        <InputText v-model="form.password" name="password" type="password" />
      </InertiaFormField>
      <InertiaFormField
        :label="t('form.password_confirmation.label')"
        required
        :error="form.errors.password_confirmation">
        <InputText v-model="form.password_confirmation" name="password_confirmation" type="password" />
      </InertiaFormField>
    </template>

    <template #footer>
      <div class="flex justify-end">
        <Button :label="t('form.submit.label')" :loading="form.processing" @click="form.post(password.store().url)" />
      </div>
    </template>
  </AuthCard>
</template>

<i18n>
{
  "en": {
    "title": "Reset Password",
    "subtitle": "Choose your new password",
    "form": {
      "password": {
        "label": "New Password"
      },
      "password_confirmation": {
        "label": "Confirm Password"
      },
      "submit": {
        "label": "Reset Password"
      }
    }
  },
  "de": {
    "title": "Passwort zurücksetzen",
    "subtitle": "Wähle hier dein neues Passwort",
    "form": {
      "password": {
        "label": "Neues Passwort"
      },
      "password_confirmation": {
        "label": "Passwort bestätigen"
      },
      "submit": {
        "label": "Passwort zurücksetzen"
      }
    }
  }
}
</i18n>
